import { ColumnDef } from "@tanstack/react-table";
import DataTable, { Cell } from "../components/table/ServerSideTable";
import { useEarmoldsPaginated } from "../hooks/earmolds.hooks";
import { Earmold } from "../types/earmold.types";
import { useMemo, useRef, useState } from "react";
import ProductBadge from "../components/ProductBadge";
import SimpleModal from "../components/modals/SimpleModal";
import { useDisclosure } from "@chakra-ui/react";
import EarmoldForm, {
	EarmoldFormHandler,
} from "../components/forms/EarmoldForm";
import { useMutation, useQueryClient } from "react-query";
import { updateEarmold } from "../mutations/earmold.mutations";

const EarmoldTab = () => {
	const productModal = useDisclosure();
	const productModalRef = useRef<EarmoldFormHandler>(null);
	const [selectedEarmold, setSelectedEarmold] = useState<Earmold | null>(null);
	const columns = useMemo<ColumnDef<Earmold>[]>(() => {
		return [
			{
				accessorFn: (row) => row.label,
				id: "name",
				header: "Embouts",
				cell: (info) => info.getValue(),
				sortDescFirst: true,
			},
			{
				accessorFn: (row) => <ProductBadge status={row.status}></ProductBadge>,
				id: "status",
				header: "Statut",
				cell: (info) => info.getValue(),
				sortDescFirst: true,
			},
		];
	}, []);
	const queryClient = useQueryClient();
	const { mutate: mutateUpdateEarmold } = useMutation(updateEarmold, {
		onSuccess: () => {
			queryClient.invalidateQueries("earmolds-paginated");
		},
	});
	const handleUpdate = async () => {
		if (productModalRef.current) {
			const valid = await productModalRef.current.valid();
			if (valid) {
				const earmold = productModalRef.current.values();
				mutateUpdateEarmold({
					id: selectedEarmold?.id,
					earmold,
				});
				productModal.onClose();
			}
		}
	};

	return (
		<>
			<DataTable
				columns={columns}
				paginatedQuery={useEarmoldsPaginated}
				w={["auto", "12rem"]}
				flexGrow={[1, 0]}
				cellLink={(cell: Cell) => {
					if (cell.id.includes("name")) {
						return `/products/earmolds/${cell.row.id}`;
					}
				}}
				handleCellClick={(cell: Cell) => {
					if (cell.id.includes("status")) {
						setSelectedEarmold(cell.row);
						productModal.onOpen();
					}
				}}
			></DataTable>
			<SimpleModal
				isOpen={productModal.isOpen}
				onClose={productModal.onClose}
				title="Modifier un produit"
				onClick={handleUpdate}
				isUpdate
			>
				<EarmoldForm
					ref={productModalRef}
					value={selectedEarmold ?? undefined}
				/>
			</SimpleModal>
		</>
	);
};

export default EarmoldTab;
